module.exports = __webpack_public_path__ + "static/tema_destacado-febrero-002d0dc7718a1d0a6ba28c5fea6e8f18.jpg";